<template>
    <div class="text-block block-card card-border ">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header>
                    <div class="block-card-title handle">
                        <div class="title-icon">
                            <img src="../../../../assets/img/ic_textcard.png" alt="">
                        </div>

                        <h4>Text Block</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <vTextareaAutocomplete v-model="data.text" :type="'textarea'"
                                           :validationRules="autocompleteValidationRules"></vTextareaAutocomplete>
                    <buttons-list :buttons="data.buttons" :blocks-list="blocksList"></buttons-list>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import vTextareaAutocomplete from "../../../common/v-textarea-autocomplete"
    import buttonsList from './common-inner-blocks/button-list'
    import VueTribute from 'vue-tribute'
    import Tribute from "tributejs";

    export default {
        name: "text-block",
        components: {
            buttonsList,
            VueTribute,
            // vTextareaAutocomplete
        },
        props: {
            data: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            index: {
                type: Number,
                default: () => {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                autocompleteValidationRules: [
                    v => !!v || 'Text is Required'
                ]

            }
        },
        mounted() {
            if (!this.data.buttons) {
                this.data.buttons = []
            }
        },
        methods: {},
        computed: {},
        watch: {}
    }
</script>

<style scoped>

</style>